// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../../../Fields/FieldsImport';
import { FieldsFactory } from '../../../Factory/FieldsFactory';
export class AlgorithmGainersLosersInstrumentGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ALGORITHM_GAINERS_LOSERS_INSTRUMENT_GROUP, null, pfixFieldSet);
    }
    get Behavior() {
        return super.GetValue(FieldsFactory.FIELD_BEHAVIOR);
    }
    get InstrumentId() {
        return super.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
    }
    get InstrumentName() {
        return super.GetValue(FieldsFactory.FIELD_NAME);
    }
    get InstrumentTypeId() {
        return super.GetValue(FieldsFactory.FIELD_INSTRUMENTTYPE_ID);
    }
    get InterestChange() {
        return super.GetValue(FieldsFactory.FIELD_INTEREST_CHANGE);
    }
    get LastPrice() {
        return super.GetValue(FieldsFactory.FIELD_LAST_PRICE);
    }
    get MarketDataExchange() {
        return super.GetValue(FieldsFactory.FIELD_MARKET_DATA_EXCHANGE);
    }
    get RouteID() {
        return super.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    get TradableInsID() {
        return super.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    get TradingExchange() {
        return super.GetValue(FieldsFactory.FIELD_TRADING_EXCHANGE);
    }
    get Volume() {
        return super.GetValue(FieldsFactory.FIELD_VOLUME);
    }
}
